import { NextSeo, type NextSeoProps } from 'next-seo';

interface Props
  extends Pick<NextSeoProps, 'title' | 'description' | 'canonical'> {
  image: string;
  imageWidth?: string;
  imageHeight?: string;
  type?: string;
  url?: string;
}

export default function SeoConfig({
  title,
  description,
  image,
  imageWidth = '1200',
  imageHeight = '670',
  url = 'https://www.vusocial.com',
  canonical = 'https://www.vusocial.com/',
  type = 'website',
}: Props) {
  return (
    <NextSeo
      title={title}
      description={description}
      canonical={canonical}
      additionalMetaTags={[
        // Twitter Card
        { property: 'twitter:title', content: title },
        { property: 'twitter:description', content: description },
        { property: 'twitter:image', content: image },
      ]}
      openGraph={{
        title,
        description,
        url,
        type,
        siteName: 'Vusocial',
        images: [
          {
            url: image,
            width: Number(imageWidth),
            height: Number(imageHeight),
            alt: 'vusocial',
          },
        ],
      }}
      twitter={{
        cardType: 'summary_large_image',
      }}
    />
  );
}
